"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var AnchorLink = function AnchorLink(_ref) {
  var href = _ref.href,
    children = _ref.children,
    className = _ref.className,
    external = _ref.external,
    id = _ref.id;
  return external ? /*#__PURE__*/_react["default"].createElement("a", {
    className: className,
    href: href,
    target: "_blank",
    rel: "noopener noreferrer",
    id: id
  }, children) : /*#__PURE__*/_react["default"].createElement("a", {
    className: className,
    href: href,
    id: id
  }, children);
};
AnchorLink.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].any,
  className: _propTypes["default"].string,
  external: _propTypes["default"].bool,
  id: _propTypes["default"].string
};
var _default = exports["default"] = AnchorLink;